import { getElementHeadingValue, getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../../constants';
export const Definition = {
  // data-onboarding-name as popover is from the shared component and used within
  // several different tour scenarios. We only want to track ones also with
  // our nudge type attribute.
  //
  // Note that when onboarding tours show modals they will be tracked by the
  // modal-trellis definition and are expected to have a nudge type override
  selector: '[data-onboarding-name="popover"][data-nudge-type="ONBOARDING_TOUR"]',
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    var _getElementHeadingVal, _header$nextElementSi;
    const title = (_getElementHeadingVal = getElementHeadingValue(element)) !== null && _getElementHeadingVal !== void 0 ? _getElementHeadingVal : 'no-title';
    const header = element.querySelector('header');
    const textContainer = header === null || header === void 0 || (_header$nextElementSi = header.nextElementSibling) === null || _header$nextElementSi === void 0 ? void 0 : _header$nextElementSi.querySelector('div');
    const text = isHTMLElement(textContainer) ? getTranslationOrInnerText(textContainer) : 'no-text';
    return {
      type: NudgeTypes.ONBOARDING_TOUR,
      title,
      text
    };
  }
};